import React from 'react';
import i18n from 'i18next';
import { has } from 'lodash';

import CreateShipment from 'components/CreateShipment';
import ScrollToTop from 'components/common/ScrollToTop';
import Authenticate from 'components/common/Authenticate';
import SetPassword from 'components/auth/SetPassword';
import ResetPassword from 'components/auth/ResetPassword';
import LoginGroup from 'components/auth/LoginGroup';

import Transactions from 'components/Account/Transactions';
import TransactionDetails from 'components/Account/Transactions/TransactionDetails';
import TransactionAdjustment from 'components/Account/Transactions/TransactionAdjustment';
import TransactionReturn from 'components/Account/Transactions/TransactionReturn';
import ReschedulePickup from 'components/Account/Transactions/ReschedulePickup';
import PaymentMethods from 'components/Account/PaymentMethods';
import PromoCode from 'components/Account/PromoCode';
import Tracking from 'components/Tracking';

import Navigation from 'components/common/Navigation';

import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import CampaignPopup from './components/campaign/CampaignPopup';
import TermsAndConditions from './components/common/TermsAndConditions';
import RetireModal from './components/RetireModal';
import { langauges } from './i18n';

const App = () => {
  const customHistory = createBrowserHistory();
  library.add(fab, fas);

  const compilePath = path => `${process.env.PUBLIC_URL}/${localStorage.i18nextLng}${path}`;

  const ResetPasswordPage = ({ location }) => (
    <ResetPassword location={location} />
  );
  const SetPasswordPage = ({ location }) => <SetPassword location={location} />;
  const LoginGroupPage = ({ match }) => <LoginGroup page={match.params[0]} />;

  const CreateShipmentPage = ({ match, location }) => {
    const step = {
      quotation: 0,
      items: 1,
      address: 2,
      pickup: 3,
      payment: 4,
      finish: 5
    };

    if (!has(step, match.params.step))
      return <Redirect to={compilePath('/create-shipment/quotation')} />;
    return (
      <CreateShipment
        location={location}
        currentStep={step[match.params.step] || 0}
      />
    );
  };

  const LangRoute = ({ component: Component, ...rest }) => {
    const { hash, search } = rest?.location;
    const lang = rest?.computedMatch?.params?.lang;

    if (langauges.includes(lang)) {
      if (localStorage.i18nextLng !== lang) i18n.changeLanguage(lang);
      return <Route {...rest} render={props => <Component {...props} />} />;
    } else {
      const path = rest.computedMatch.url.replace(`/${lang}`, '');
      return <Redirect to={`${process.env.PUBLIC_URL}/${localStorage.i18nextLng}${path}${search}${hash}`} />;
    }
  };

  return (
    <Router history={customHistory}>
      <Authenticate>
        <ScrollToTop>
          <Navigation>
            <RetireModal />
            <CampaignPopup>
              <Switch>
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/create-shipment/:step?`}
                  component={CreateShipmentPage}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/set-password`}
                  component={SetPasswordPage}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/reset-password`}
                  component={ResetPasswordPage}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/(login|register|forgot-password)`}
                  component={LoginGroupPage}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/orders/reschedule-pickup/:ref`}
                  component={ReschedulePickup}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/orders/adjustment/:ref`}
                  component={TransactionAdjustment}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/orders/return/:ref`}
                  component={TransactionReturn}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/orders/:ref`}
                  component={TransactionDetails}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/orders`}
                  component={Transactions}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/payment-methods`}
                  component={PaymentMethods}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/account/promo-codes`}
                  component={PromoCode}
                />
                <LangRoute
                  path={`${process.env.PUBLIC_URL}/:lang?/tracking/:trackingNumber`}
                  component={Tracking}
                />
                <Redirect to={compilePath('/create-shipment/quotation')} />
              </Switch>
            </CampaignPopup>
            <TermsAndConditions />
          </Navigation>
        </ScrollToTop>
      </Authenticate>
    </Router>
  );
};

export default App;
